<template>
  <div class="download-module-background">
    <div class="download-module-banner">
      <div class="download-module-container">
        <div class="download-module-banner-title">Bug日志</div>
      </div>

      <img class="download-module-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="download-module-container">

     <div class="download-module-content">
       <div class="download-module-content-title">
         <div class="download-module-content-title-text">Bug日志</div>
         <div class="download-module-line"></div>
       </div>

       <div class="download-module-content-info">
         <table class="download-module-table" >
           <tr class="download-module-th">
             <th class="download-module-text-th">提问时间</th>
             <th class="download-module-text-th">提问人</th>
             <th class="download-module-text-th">问题</th>
             <th class="download-module-text-th">下载</th>
             <th class="download-module-text-th">进度/答案</th>
             <th class="download-module-text-th">是否解决</th>
             <th class="download-module-text-th">解决时间</th>
           </tr>
           <tbody v-for="(log,index) in testLog" >
             <tr class="download-module-td">
               <td class="download-module-text-td">{{log.time}}</td>
               <td class="download-module-text-td">{{log.ask_man}}</td>
               <td class="download-module-text-td">{{log.summary}}</td>
               <td class="download-module-text-td"><a class="download-module-a" :href="log.download" v-if="log.download">{{log.download.slice(56)}}</a></td>
               <td class="download-module-text-td">{{log.answer}}</td>
               <td class="download-module-text-td">{{log.resolve}}</td>
               <td class="download-module-text-td">{{log.resolve_time}}</td>
             </tr>
           </tbody>

         </table>
       </div>

     </div>
    </div>
  </div>
</template>

<script>
  import {moduleDownload} from "../../helpers/moduleDownload"
  import {MODULE_DOWNLOAD,CMS_API_NEWS_IMG} from "../../helpers/consts";
  import {mapState} from 'vuex'

  export default {
    name: "companyIntroduce",
    data(){
      return {
        moduleDownload,
        MODULE_DOWNLOAD,
        isShowModuleInfo:false,
        showModuleInfoId:'',
        CMS_API_NEWS_IMG
      }
    },
    computed: {
      ...mapState({
        testLog: state => state.TestLog.testLog.info,
      })
    },
    created(){
      this.$store.dispatch('getTestLog').then(res => {

      })
    },
    methods:{

    }
  }
</script>

<style scoped>
  .download-module-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .download-module-background{
    margin-top: 70px;
  }
  .download-module-banner{
    overflow:hidden;
  }
  .download-module-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .download-module-banner-img{
    min-width:100%;
    height:165px;
  }
  .download-module-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .download-module-content-title{
    padding-top: 50px;
  }
  .download-module-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .download-module-content-info{
    margin-top: 40px;
  }
  .download-module-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .download-module-content-info-text-td{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
    margin-top: 4px;
    margin-bottom: 4px;
  }
  .download-module-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }
  .download-module-content-img{
    text-align: center;
  }
  .download-module-content-img-png{
    margin-top: 50px;
    width: 800px;
  }
  .download-module-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .download-module-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .download-module-td{
    height: 45px;
  }
  .download-module-td-info{
    height: 45px;
    padding: 16px 32px;
    background:rgba(73,145,201,0.05);
  }
  .download-module-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding:8px 16px;
  }
  .download-module-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding:8px 16px;
  }
  .download-module-a{
    color:rgba(73,145,201,1)!important;
    cursor: pointer;
  }

  @media screen and (max-width:482px) {
    .download-module-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .download-module-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .download-module-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .download-module-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .download-module-container{
      max-width: 1068px;
    }
  }

</style>